import loadable from '@loadable/component'

export default [
  {
    path: '/game/family/egg',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine" */ '~/pages/game/FamilyEggMachine'
        )
    ),
  },
  {
    // 排行榜
    path: '/game/family/egg/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine-Rank" */ '~/pages/game/FamilyEggMachine/SubPages/Rank'
        )
    ),
  },

  {
    // gift note
    path: '/game/family/egg/note',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine-note" */ '~/pages/game/FamilyEggMachine/SubPages/GiftNote'
        )
    ),
  },
  {
    // 消费提示页
    path: '/game/family/egg/modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-EggMachine-Modal" */ '~/pages/game/FamilyEggMachine/SubPages/Modal'
        )
    ),
  },
]
